import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock } from "vue"

import { computed, ref, watch } from 'vue';
import { HasManyFieldType } from '@/components/business/crud/interface/FieldType';
import { WidgetInfo } from '@/components/business/crud/widgets/WidgetContainer';
import { ScForm } from '@/models/ScForm';
import HasMany from '@/components/business/crud/widgets/impl/component/HasMany.vue';
import SelectModelTable from '@/components/business/crud/common/SelectModelTable.vue';


import { definedWidgetMeta } from '@/components/business/crud/widgets/widgetManager';

export const meta = definedWidgetMeta({
  size: { edit: 'large', show: 'large' },
});


export default /*#__PURE__*/_defineComponent({
  __name: 'HasManyForm',
  props: {
    propName: {},
    widget: {},
    info: {}
  },
  setup(__props: any) {

const props = __props;
const data = ScForm.useFormData();
const isCreate = computed(() => !data.value[props.widget.localPrimary]);

const models = ref([])
watch(models, () => {
  if (!data.value[props.propName]) {
    data.value[props.propName] = {};
  }
  data.value[props.propName].attach = models.value.map((i: any) => i[props.widget.targetPrimary]);
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (isCreate.value)
      ? (_openBlock(), _createBlock(SelectModelTable, {
          key: 0,
          modelValue: models.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((models).value = $event)),
          "module-name": _ctx.widget.targetModuleName,
          "controller-name": _ctx.widget.targetController,
          "label-name": _ctx.widget.targetLabel
        }, null, 8, ["modelValue", "module-name", "controller-name", "label-name"]))
      : (_openBlock(), _createBlock(HasMany, {
          key: 1,
          data: _unref(data),
          info: _ctx.info,
          "prop-name": _ctx.propName,
          widget: _ctx.widget
        }, null, 8, ["data", "info", "prop-name", "widget"]))
  ]))
}
}

})